import { useStore } from '../store/store';
import { shallow } from 'zustand/shallow';

// Field type definition
export interface NodeField {
  name: string;
  type: string;
}

// Return type for useNodeFields hook
export interface NodeFields {
  incomingFields: NodeField[];
  outgoingFields: NodeField[];
}

// Hook to get node fields
export const useNodeFields = (nodeId: string): NodeFields => {
  return useStore((state) => {
    const activePipeline = state.pipelines.find((p) => p.id === state.activePipelineId);
    const node = activePipeline?.nodes.find((n) => n.id === nodeId);
    return {
      incomingFields: node?.data?.incomingFields || [],
      outgoingFields: node?.data?.outgoingFields || [],
    };
  }, shallow);
};

// Helper to format fields for tooltip - returns string instead of JSX
export const formatFieldsForTooltip = (fields: NodeField[]): string => {
  if (!fields || fields.length === 0) {
    return 'No fields defined';
  }

  const fieldsList = fields.map((field) => `  ${field.name} (${field.type})`).join('\n');

  return `Fields:\n${fieldsList}`;
};
